(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fl4-sticky-buy"] && !Shopify.designMode) return;
  try {
    (() => {
  function initStickyBuy() {
    const bar=document.querySelector('[data-fl4-sticky-buy]');
    const form=document.querySelector('#fl4-product-form');
    const main=form?.querySelector('.fl4-add');
    if(!bar || !form || !main || bar.dataset.initialized)return;
    bar.dataset.initialized='true';
    const add=bar.querySelector('[data-sticky-add]');
    const price=bar.querySelector('[data-sticky-price]');
    const compare=bar.querySelector('[data-sticky-compare]');
    const size=bar.querySelector('[data-sticky-size]');
    const originalSizePrefix=size?.textContent.trim().split(' ')[0] || '';
    let frame;
    function sync() {
      price.textContent=document.querySelector('[data-fl4-product-price]')?.textContent || '';
      const source=document.querySelector('[data-fl4-product-compare]');
      compare.textContent=source?.textContent || '';
      compare.hidden=!source || source.classList.contains('is-hidden') || !compare.textContent.trim();
      const selected=form.querySelector('.fl4-variant-input:checked');
      if(size && selected)size.textContent=originalSizePrefix+' '+selected.dataset.title;
      const busy=main.getAttribute('aria-busy')==='true' || main.classList.contains('is-fl4-cart-animating') || (main.disabled && selected?.dataset.available==='true');
      add.disabled=main.disabled || busy;
      add.textContent=busy ? add.dataset.loadingLabel : main.disabled ? add.dataset.soldLabel : add.dataset.addLabel;
      add.setAttribute('aria-busy',busy ? 'true' : 'false');
      const blocked=Array.from(document.querySelectorAll('#fl4-cart,#fl4-menu,#fl4-search,#fl4-size-modal,#fl4-filter-drawer')).some(el=>el.classList.contains('is-open'));
      const visible=main.getBoundingClientRect().bottom<=0 && !blocked;
      bar.classList.toggle('is-visible',visible);
      bar.setAttribute('aria-hidden',visible ? 'false' : 'true');
      bar.inert=!visible;
      document.body.classList.toggle('fl4-has-sticky-buy',visible);
      document.body.style.setProperty('--fl4-sticky-height',bar.getBoundingClientRect().height+'px');
    }
    function schedule(){if(frame)return;frame=requestAnimationFrame(()=>{frame=0;sync()});}
    add.addEventListener('click',()=>{if(!main.disabled && main.getAttribute('aria-busy')!=='true'){main.click();sync()}});
    size?.addEventListener('click',()=>{const selected=form.querySelector('.fl4-variant-input:checked');const target=selected?.closest('.fl4-size-grid') || form;target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});selected?.focus({preventScroll:true});});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    form.addEventListener('change',schedule);
    const observer=new MutationObserver(schedule);
    observer.observe(main,{attributes:true,childList:true,subtree:true});
    document.querySelectorAll('[data-fl4-product-price],[data-fl4-product-compare]').forEach(el=>observer.observe(el,{attributes:true,childList:true,subtree:true}));
    document.querySelectorAll('#fl4-cart,#fl4-menu,#fl4-search,#fl4-size-modal,#fl4-filter-drawer').forEach(el=>observer.observe(el,{attributes:true,attributeFilter:['class']}));
    const resize=new ResizeObserver(schedule);resize.observe(bar);
    sync();
    document.addEventListener('shopify:section:unload',event=>{if(!event.target.contains(form))return;window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);observer.disconnect();resize.disconnect();document.body.classList.remove('fl4-has-sticky-buy');},{once:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initStickyBuy);else initStickyBuy();
  document.addEventListener('shopify:section:load',initStickyBuy);
})();
  } catch(e) { console.error(e); }
})();

})();
